/**
 * Bir onRow olayı (tıklama/çift tıklama) gerçekten grid satırının kendisinden mi geliyor?
 *
 * Satır menüsünün içinde render edilen antd Modal/Dropdown/Popconfirm gövdeye (document.body)
 * portal ile taşınır; ama React olayları DOM ağacında değil BİLEŞEN ağacında baloncuklanır —
 * portal içindeki tıklama yine satırın onClick/onDoubleClick handler'ına ulaşır. Bu yüzden
 * "Yeniden Değerlendirme İsteği" modalında metin seçmek için çift tıklamak rapor önizlemesini
 * açıyordu. Olayın DOM hedefi bir satırın içinde değilse handler'ı çalıştırmıyoruz.
 *
 * Satır seçici olarak `tr[data-row-key]` kullanılır (antd tablo satırları); aynı seçici
 * useRowDetailDrawer'daki click-away mantığında da geçiyor.
 */
export function isRowEvent(event) {
    const target = event?.target;

    if (!target || typeof target.closest !== 'function')
        return false;

    return !!target.closest('tr[data-row-key]');
}
